import React from "react";
import { StyledOverlay, StyledSidePanel } from "./SidePanel.styled";
import { TitlesTyp } from "../../Typography/Typography";
import {
  AlignmentEnum,
  FontWeightEnum,
  IconSizeEnum,
} from "../../../types/AppTypes";
import { DoubleStructure } from "../DoubleStructure/DoubleStructure";
import { IconManager } from "../IconManager/IconManager";
import { theme } from "../../../constants/StyledComponents";
import { ReactComponent as CloseIcon } from "../../../icons/close.svg";
import { Loader } from "../Loader/Loader";

type SidePanelProps = {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  visible: boolean;
  onClose: () => void;
  label: string;
  loading?: boolean;
};

export const SidePanel = ({
  children,
  footer = null,
  header = null,
  visible,
  onClose,
  label,
  loading = false,
}: SidePanelProps) => {
  return (
    <>
      <StyledOverlay $visible={visible} onClick={onClose} />
      <StyledSidePanel $visible={visible}>
        <>
          <div className="panel-header">
            <DoubleStructure verticalAlignment={AlignmentEnum.CENTER}>
              <TitlesTyp variant="3" fontWeight={FontWeightEnum.SEMIBOLD}>
                {label}
              </TitlesTyp>
              <IconManager
                color={theme.colors.black}
                size={IconSizeEnum.MEDIUM}
                onClick={onClose}
              >
                <CloseIcon />
              </IconManager>
            </DoubleStructure>
          </div>
          {header}
        </>
        {loading ? (
          <Loader className="panel-loader" loading={loading} />
        ) : (
          <div className="panel-content">{children}</div>
        )}

        {footer && <div className="panel-footer">{footer}</div>}
      </StyledSidePanel>
    </>
  );
};
